import { PageAction } from '@e3dc-react/shell/State/App/AppModel'
import { useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import MobileHeaderBar from 'src/Elements/Navigation/MobileHeaderBar'
import { useTypedSelector } from 'src/State/RootReducer'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { useNavigate } from 'react-router-dom'
import Header from './Header'
import { useFarmSelectorLocation } from 'src/Libs/farm/hooks'
import { useFarmContext } from 'src/Elements/Farm'
import { useHeaderHeight, useHeaderTabs as useHeaderTabsNext } from '@e3dc-react/shell/Libs/Header'
import FarmSelector from './FarmSelector'
import { usePageActionsContext } from 'src/Libs/header/context'
import { useIsWebviewMode } from 'src/Hooks'

interface Props {
  handleDrawerOpenToggle: () => void
  setWithTabs: (value: boolean) => void
  setHeaderHeight: (value: number) => void
  activeStorage?: string
}

/**
 * Component contains two header variants based on the screen size.
 */
const HeaderWrapper: React.FC<Props> = ({ activeStorage, setHeaderHeight, setWithTabs, handleDrawerOpenToggle }) => {
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const isWebView = useIsWebviewMode()
  const moreActive = useTypedSelector(state => state.app.moreActive)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const title = useTypedSelector(state => state.app.title)
  const activeTab = useTypedSelector(store => store.navigation.headerTab)
  const { isFarm } = useFarmContext()
  const { farmAndClientsSelectorIsAllowed, farmSelectorIsAllowed } = useFarmSelectorLocation()
  const headerTabsNext = useHeaderTabsNext()
  const tabs = headerTabsNext.tabs
  const { height } = useHeaderHeight()
  const { pageActions } = usePageActionsContext()

  const customContent = (
    <FarmSelector
      activeStorage={activeStorage}
      isFarmAndClientsAllowedPage={farmAndClientsSelectorIsAllowed}
      isOnlyFarmAllowedPage={farmSelectorIsAllowed}
    />
  )

  const hideTitle = useMemo(
    () => isFarm && (farmAndClientsSelectorIsAllowed || farmSelectorIsAllowed),
    [farmAndClientsSelectorIsAllowed, isFarm, farmSelectorIsAllowed]
  )

  const handleMobileMenuOpenToggle = (): void => {
    if (!isWebView) dispatch(appUpdate({ moreActive: !moreActive }))
  }

  const handleLeftAction = (type: PageAction): void => {
    if (type === 'back') {
      navigate(-1)
    }
  }

  useEffect(() => {
    setWithTabs(tabs.length > 0)
  }, [setWithTabs, tabs])

  useEffect(() => {
    setHeaderHeight(height)
  }, [height, setHeaderHeight])

  if (mdDown)
    return (
      <MobileHeaderBar
        title={title}
        handleLeftAction={handleLeftAction}
        pageActions={pageActions ?? []}
        handleDrawerToggle={handleMobileMenuOpenToggle}
        hasMenu={!isWebView}
        tabs={tabs}
        activeTab={activeTab}
        customContent={customContent}
        showTitle={!hideTitle}
      />
    )
  return (
    <Header
      onDrawerToggle={handleDrawerOpenToggle}
      alwaysShowTitle
      tabs={tabs}
      activeTab={activeTab}
      customContent={customContent}
      showTitle={!hideTitle}
      pageActions={pageActions}
    />
  )
}

export default HeaderWrapper
